import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { GenderFailure, GenderRequest, GenderSuccess } from './actions';
import { GenderService } from './service';

@Injectable()
export class GenderEffects {
  private readonly actions$ = inject(Actions);
  private readonly genderService = inject(GenderService);

  gender$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GenderRequest),
      switchMap(({ parameters }) =>
        this.genderService.gender(parameters).pipe(
          map(data => GenderSuccess({ data })),
          catchError(error => of(GenderFailure({ error })))
        )
      )
    )
  );

}
